export function alpha(hex: string, a: number): string {
  return `${hex}${Math.round(a * 255).toString(16).padStart(2, '0')}`;
}

export const PALETTE = {
  light: {
    bg: '#FFFFFF', surface: '#FFFFFF', surfaceAlt: '#FFF7ED',
    border: '#D8DCE4', borderLight: '#E4E7ED', mapBg: '#FFF7ED',
    text: '#1A1D26', textMuted: '#6B7280',
    accent: '#EA580C', accentDim: '#FFEDD5', accentLight: 'rgba(234,88,12,0.06)',
    danger: '#DC4545', dangerDim: 'rgba(220,69,69,0.08)',
    success: '#16A34A', successDim: 'rgba(22,163,74,0.08)',
    warning: '#E8700A', warningDim: 'rgba(232,112,10,0.1)',
    shadow: '0 1px 3px rgba(0,0,0,0.08)', shadowLg: '0 4px 14px rgba(0,0,0,0.12)',
    gridLine: '#C8CDD8', gridOp: '0.5',
    ghostBorder: 'rgba(0,0,0,0.18)', ghostBg: 'rgba(0,0,0,0.03)', ghostText: 'rgba(0,0,0,0.3)',
    houseEmpty: '#2A2D35', houseNormal: '#16A34A', houseWarning: '#E8700A', houseDanger: '#DC4545',
    houseEmptyBg: 'rgba(42,45,53,0.12)', houseNormalBg: 'rgba(22,163,74,0.12)',
    houseWarningBg: 'rgba(232,112,10,0.12)', houseDangerBg: 'rgba(220,69,69,0.12)',
    favActive: '#F59E0B', favInactive: '#D1D5DB', favGlow: '#FACC15',
    tableRowHover: 'rgba(234,88,12,0.04)', tableRowSel: 'rgba(234,88,12,0.08)',
    modalOverlay: 'rgba(0,0,0,0.35)',
    anomalyAcknowledged: '#6366F1', anomalyAcknowledgedBg: 'rgba(99,102,241,0.08)',
    anomalyResolving: '#0D9488', anomalyResolvingBg: 'rgba(13,148,136,0.08)',
    surfaceA88: '#FFFFFF88', surfaceCc: '#FFFFFFcc',
  },
  dark: {
    bg: '#0D0F14', surface: '#151820', surfaceAlt: '#1A1E28',
    border: '#2A2F3C', borderLight: '#363D4E', mapBg: '#111418',
    text: '#E8EAF0', textMuted: '#8B91A3',
    accent: '#FB923C', accentDim: 'rgba(251,146,60,0.15)', accentLight: 'rgba(251,146,60,0.06)',
    danger: '#EF6C6C', dangerDim: 'rgba(239,108,108,0.1)',
    success: '#3ECF7B', successDim: 'rgba(62,207,123,0.1)',
    warning: '#F5A54A', warningDim: 'rgba(245,165,74,0.1)',
    shadow: '0 1px 3px rgba(0,0,0,0.2)', shadowLg: '0 4px 12px rgba(0,0,0,0.3)',
    gridLine: '#E8EAF0', gridOp: '0.05',
    ghostBorder: 'rgba(255,255,255,0.12)', ghostBg: 'rgba(255,255,255,0.02)', ghostText: 'rgba(255,255,255,0.25)',
    houseEmpty: '#8B91A3', houseNormal: '#3ECF7B', houseWarning: '#F5A54A', houseDanger: '#EF6C6C',
    houseEmptyBg: 'rgba(139,145,163,0.1)', houseNormalBg: 'rgba(62,207,123,0.12)',
    houseWarningBg: 'rgba(245,165,74,0.12)', houseDangerBg: 'rgba(239,108,108,0.12)',
    favActive: '#FBBF24', favInactive: '#4B5563', favGlow: '#FDE047',
    tableRowHover: 'rgba(251,146,60,0.06)', tableRowSel: 'rgba(251,146,60,0.1)',
    modalOverlay: 'rgba(0,0,0,0.6)',
    anomalyAcknowledged: '#818CF8', anomalyAcknowledgedBg: 'rgba(129,140,248,0.12)',
    anomalyResolving: '#2DD4BF', anomalyResolvingBg: 'rgba(45,212,191,0.12)',
    surfaceA88: '#15182088', surfaceCc: '#151820cc',
  },
} as const;

export type Palette = {
  [K in keyof typeof PALETTE.light]: string;
};

export function getPalette(isDark: boolean): Palette {
  return isDark ? PALETTE.dark : PALETTE.light;
}
